import React from "react";
import "./sub.css";
import "../Sub/common.css";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { home, siteLogo as logo } from "../../const";

const Header = () => {
  let width = window.innerWidth;

  return (
    <>
      {/* logo menu */}
      <div className="container-fluid">
        <Row>
          <Col className="text-center">
            <Link to={home}>
              <img
                className={`${width > 468 ? `w-10` : `w-50`}`}
                src={logo}
                alt={"LK CHAT"}
              />
            </Link>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default Header;
